import React from "react";
import { Navigate } from "react-router-dom";

const ControlEventsListComponent = React.lazy(
  () => import("../../../../../components/control-event/components/list/page"),
);
const ControlEventsAddComponent = React.lazy(
  () => import("../../../../../components/control-event/components/add/page"),
);
const ControlEventsLiveComponent = React.lazy(
  () => import("../../../../../components/control-event/components/live/page"),
);
const ControlEventsScheduleComponent = React.lazy(
  () => import("../../../../../components/control-calendar/components/page"),
);
const ControlEventsShowComponent = React.lazy(
  () => import("../../../../../components/control-event/components/show/page"),
);

export const controlEventsRoutes = [
  {
    path: "list",
    element: <ControlEventsListComponent />,
  },
  {
    path: "add",
    element: <ControlEventsAddComponent />,
  },
  {
    path: "live",
    element: <Navigate to="/control/events/live" />,
  },
  {
    path: "live/:id",
    element: <ControlEventsLiveComponent />,
  },
  {
    path: "show",
    element: <Navigate to="/control/events/show" />,
  },
  {
    path: "show/:id",
    element: <ControlEventsShowComponent />,
  },
  {
    path: "edit",
    element: <Navigate to="/control/events/add" />,
  },
  {
    path: "edit/:id",
    element: <ControlEventsAddComponent />,
  },
  {
    path: "schedule",
    element: <ControlEventsScheduleComponent />,
  },
  {
    path: "",
    element: <Navigate replace to="/control/events/list" />,
  },
];
